import React, { Component } from "react";
import { connect } from "react-redux";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
// import uuid from "uuid/v4";
import {
  openProposalResponseModal,
  updateProposalStatus,
  fetchUnreviewedproposal,
  fetchReviewedproposal,
  fetchShortlistedproposal,
  fetchRejectedproposal,
  fetchallproposal,
  updatedDragProposal,
  filterProposalLoader,
  deleteProposalRank,
  sortByfilter,
} from "ProposalAction";
import { converDateIntoLocalwithmonth } from "Constants";
import { showError, showSuccess } from "ReduxErrorBar";
import _ from "lodash";
import ShimmerEffect from "./shimmer";
import LocaleStrings from "Languages";

var Loader = require("react-loaders").Loader;
class DragableProposal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      copied: false,
      loading: false,
      welcomelogin: false,
      sendwelcomemail: false,
      columns: [],
      update: false,
      nonClickableid: "",
      shimmerLoading: false,
      sortby: "none",
      sortupdate: false,
    };
  }
  componentDidMount() {
    var {
      unreviewedproposalList,
      reviewedproposalList,
      shortlistedproposalList,
      rejectedproposalList,
      allresponseProposal,
    } = this.props;

    let unreviewedproposalListArr = [];
    let reviewedproposalListArr = [];
    let shortlistedproposalListArr = [];
    let rejectedproposalListArr = [];
    let unreviewedproposalLength = 0;
    let reviewedproposalLength = 0;
    let shortlistedproposalLength = 0;
    let rejectedproposalLength = 0;

    if (!_.isEmpty(this.props.allresponseProposal)) {
      unreviewedproposalListArr.push(allresponseProposal.unreviewedArr);
      reviewedproposalListArr.push(allresponseProposal.reviewedArr);
      shortlistedproposalListArr.push(allresponseProposal.shortlistedArr);
      rejectedproposalListArr.push(allresponseProposal.rejectedArr);
      unreviewedproposalLength = allresponseProposal.unreviewedArr.length;
      reviewedproposalLength = allresponseProposal.reviewedArr.length;
      shortlistedproposalLength = allresponseProposal.shortlistedArr.length;
      rejectedproposalLength = allresponseProposal.rejectedArr.length;
    }

    const responsegridArr = {
      [0]: {
        name: "Unreviewed",
        items:
          unreviewedproposalListArr != undefined &&
          unreviewedproposalListArr.length > 0
            ? unreviewedproposalListArr[0]
            : [],
        length: unreviewedproposalLength,
        bgColor: "#F6AB2E",
      },
      [1]: {
        name: "Reviewed",
        items:
          reviewedproposalListArr != undefined &&
          reviewedproposalListArr.length > 0
            ? reviewedproposalListArr[0]
            : [],
        length: reviewedproposalLength,
        bgColor: "#105EFB",
      },
      [2]: {
        name: "Shortlisted",
        items:
          shortlistedproposalListArr != undefined &&
          shortlistedproposalListArr.length > 0
            ? shortlistedproposalListArr[0]
            : [],
        length: shortlistedproposalLength,
        bgColor: "#22B576",
      },
      [3]: {
        name: "Rejected",
        items:
          rejectedproposalListArr != undefined &&
          rejectedproposalListArr.length > 0
            ? rejectedproposalListArr[0]
            : [],
        length: rejectedproposalLength,
        bgColor: "#FF6868",
      },
    };
    this.setState({ columns: responsegridArr });
  }
  componentWillReceiveProps(nextProps) {
    // console.log('test',this.state.update);
    if (
      this.state.update == true ||
      nextProps.updatedProposalLoader.updated === true
    ) {
    
      var { allresponseProposal } = nextProps;
      let unreviewedproposalListArr = [];
      let reviewedproposalListArr = [];
      let shortlistedproposalListArr = [];
      let rejectedproposalListArr = [];
      let unreviewedproposalLength = 0;
      let reviewedproposalLength = 0;
      let shortlistedproposalLength = 0;
      let rejectedproposalLength = 0;

      if (!_.isEmpty(allresponseProposal)) {
        unreviewedproposalListArr.push(allresponseProposal.unreviewedArr);
        reviewedproposalListArr.push(allresponseProposal.reviewedArr);
        shortlistedproposalListArr.push(allresponseProposal.shortlistedArr);
        rejectedproposalListArr.push(allresponseProposal.rejectedArr);
        unreviewedproposalLength = allresponseProposal.unreviewedArr.length;
        reviewedproposalLength = allresponseProposal.reviewedArr.length;
        shortlistedproposalLength = allresponseProposal.shortlistedArr.length;
        rejectedproposalLength = allresponseProposal.rejectedArr.length;
      }

      const responsegridArr = {
        [0]: {
          name: "Unreviewed",
          items:
            unreviewedproposalListArr != undefined &&
            unreviewedproposalListArr.length > 0
              ? unreviewedproposalListArr[0]
              : [],
          length: unreviewedproposalLength,
          bgColor: "#F6AB2E",
        },
        [1]: {
          name: "Reviewed",
          items:
            reviewedproposalListArr != undefined &&
            reviewedproposalListArr.length > 0
              ? reviewedproposalListArr[0]
              : [],
          length: reviewedproposalLength,
          bgColor: "#105EFB",
        },
        [2]: {
          name: "Shortlisted",
          items:
            shortlistedproposalListArr != undefined &&
            shortlistedproposalListArr.length > 0
              ? shortlistedproposalListArr[0]
              : [],
          length: shortlistedproposalLength,
          bgColor: "#22B576",
        },
        [3]: {
          name: "Rejected",
          items:
            rejectedproposalListArr != undefined &&
            rejectedproposalListArr.length > 0
              ? rejectedproposalListArr[0]
              : [],
          length: rejectedproposalLength,
          bgColor: "#FF6868",
        },
      };
      this.setState({ columns: responsegridArr });
      this.setState({ nonClickableid: "" });
      this.props.updatedDragProposal(false);
      this.setState({ update: false });
      this.setState({ shimmerLoading: false });
    }
  }

  renderLoader = () => {
    return (
      <Loader type="line-scale-pulse-out-rapid" active className="loader-div" />
    );
  };
  onDragEnd = (result, columns) => {
    this.props.filterProposalLoader(true);
    this.setState({ sortupdate: true });
    let newStatus = "";
    let markas = null;
    let sourceStatus = "";
    let attendeeList = [];
    let removedArrid = [];
    let updateproposalResponseArray = [];

    if (!result.destination) return;
    const { source, destination } = result;
    // console.log("result", result);
    if (result.destination.droppableId == "0") {
      newStatus = "unreviewed";
    } else if (result.destination.droppableId == "1") {
      newStatus = "reviewed";
    } else if (result.destination.droppableId == "2") {
      newStatus = "shortlisted";
    } else if (result.destination.droppableId == "3") {
      newStatus = "reviewed";
      markas = "reject";
    }
    const sourceColumn = columns[source.droppableId];
    const destColumn = columns[destination.droppableId];
    const sourceItems = [...sourceColumn.items];
    const destItems = [...destColumn.items];
    const [removed] = sourceItems.splice(source.index, 1);
    let responseidfk = removed.id;
    if (
      this.props.proposalAttendeeList &&
      this.props.proposalAttendeeList.resource &&
      this.props.proposalAttendeeList.resource.length > 0
    ) {
      attendeeList = _.filter(
        this.props.proposalAttendeeList.resource,
        function (o) {
          return o.email === removed.email;
        }
      );
    }

    if (
      result.source.droppableId == "0" &&
      result.destination.droppableId == "1"
    ) {
      this.props.showError("Without rating they cannot be moved to Reviewed");
      return false;
    }
    if (
      result.source.droppableId == "1" &&
      result.destination.droppableId == "0"
    ) {
      this.props.showError(
        "To move back under unreviewed tab, please mark as incomplete"
      );
      return false;
    }
    if (
      result.source.droppableId == "2" &&
      result.destination.droppableId == "0"
    ) {
      this.props.showError(
        "To move back under unreviewed tab, please mark as incomplete"
      );
      return false;
    }
    if (
      result.source.droppableId == "2" &&
      result.destination.droppableId == "1"
    ) {
      this.props.showError("User has been reviewed already");
      return false;
    }
    if (
      result.source.droppableId == "3" &&
      result.destination.droppableId == "1"
    ) {
      this.props.showError("Without rating they cannot be moved to Reviewed");
      return false;
    }
    if (
      result.source.droppableId == "3" &&
      result.destination.droppableId == "0"
    ) {
      this.props.showError(
        "To move back under unreviewed tab, please mark as incomplete"
      );
      return false;
    }

    if (
      attendeeList.length > 0 &&
      result.source.droppableId == "2" &&
      result.destination.droppableId == "3"
    ) {
      this.props.showError("Confirmed user cannot be moved to rejected");
      return false;
    }

    // console.log("attendeeList", attendeeList);
    if (source.droppableId !== destination.droppableId) {
      const sourceColumn = columns[source.droppableId];
      const destColumn = columns[destination.droppableId];
      const sourceItems = [...sourceColumn.items];
      const destItems = [...destColumn.items];
      const [removed] = sourceItems.splice(source.index, 1);

      destItems.splice(destination.index, 0, removed);

      this.setState({
        columns: {
          ...this.state.columns,
          [source.droppableId]: {
            ...sourceColumn,
            items: sourceItems,
          },
          [destination.droppableId]: {
            ...destColumn,
            items: destItems,
          },
        },
      });
      let sourceItemValArr = [];
      let destItemValArr = [];
      _.forEach(sourceItems, function (value, index) {
        let sourceItemValobj = {};
        sourceItemValobj.id = value.id;
        sourceItemValobj.eventid = value.eventid;
        sourceItemValobj.display_order = index;
        sourceItemValArr.push(sourceItemValobj);
      });

      _.forEach(destItems, function (value, index) {
        let destItemValobj = {};
        destItemValobj.id = value.id;
        destItemValobj.eventid = value.eventid;
        destItemValobj.display_order = index;
        if (value.id == removed.id) {
          destItemValobj.status = newStatus;
          destItemValobj.markas = markas;
        }
        if (
          result.source.droppableId == "1" &&
          result.destination.droppableId == "3"
        ) {
          destItemValobj.avg_rating = 0;
        }
        destItemValArr.push(destItemValobj);
      });

      removedArrid.push(removed.id);
      updateproposalResponseArray.push(...sourceItemValArr, ...destItemValArr);

      this.setState({ nonClickableid: removedArrid });
      this.setState({ shimmerLoading: true });
      this.props.updateProposalStatus(
        this.props.session,
        updateproposalResponseArray,
        (response) => {
          if (response.success == 1) {
            if (
              result.source.droppableId == "1" &&
              result.destination.droppableId == "3"
            ) {
              this.props.deleteProposalRank(
                this.props.session,
                responseidfk,
                (response) => {
                  this.props.fetchallproposal(
                    this.props.session,
                    (callback) => {
                        this.props.updatedDragProposal(true);
                        this.setState({ update: true });
                      // this.setState({ shimmerLoading: false });
                      // this.setState({ nonClickableid: "" });
                    }
                  );
                }
              );
            } else {
              this.props.fetchallproposal(this.props.session, (callback) => {
                this.props.updatedDragProposal(true);
                this.setState({ update: true });
                // this.setState({ shimmerLoading: false });
                // this.setState({ nonClickableid: "" });
              });
            }
          } else {
            this.props.showError("Error in dragging");
          }
        }
      );
    } else {
      const column = columns[source.droppableId];
      const copiedItems = [...column.items];
      const [removed] = copiedItems.splice(source.index, 1);
      copiedItems.splice(destination.index, 0, removed);
      // this.setState({
      //   ...columns,
      //   [source.droppableId]: {
      //     ...column,
      //     items: copiedItems,
      //   },
      // });
      this.setState({
        columns: {
          ...this.state.columns,
          [source.droppableId]: {
            ...sourceColumn,
            items: copiedItems,
          },
        },
      });

      let copiedItemsValArr = [];

      _.forEach(copiedItems, function (value, index) {
        let copiedItemsValobj = {};
        copiedItemsValobj.id = value.id;
        copiedItemsValobj.eventid = value.eventid;
        copiedItemsValobj.display_order = index;
        copiedItemsValArr.push(copiedItemsValobj);
      });
      // console.log('copiedItemsValArr',copiedItemsValArr);
      this.props.updateProposalStatus(
        this.props.session,
        copiedItemsValArr,
        (response) => {
          if (response.success == 1) {
            // this.props.fetchallproposal(this.props.session, (callback) => {
            //   this.setState({ update: true });
            //   this.props.updatedDragProposal(false);
            //   this.setState({ shimmerLoading: false });
            //   this.setState({ nonClickableid: "" });
            // });
          } else {
            this.props.showError("Error in dragging");
          }
        }
      );
    }
  };

  handleSortBy = (e, index, column, columnId) => {
    var sortby = e.target.value;
    let name = "Unreviewed";
    if (columnId == "1") {
      name = "Reviewed";
    } else if (columnId == "2") {
      name = "Shortlisted";
    } else if (columnId == "3") {
      name = "Rejected";
    }
    if (sortby == "highestrating") {
      let sortedDescending = _.orderBy(column.items, ["avg_rating"], ["desc"]);
      this.setState({
        columns: {
          ...this.state.columns,
          [columnId]: {
            name: name,
            bgColor: column.bgColor,
            items: sortedDescending,
            length: column.length,
          },
        },
      });
    } else if (sortby == "lowestrating") {
      let sortedAscending = _.orderBy(column.items, ["avg_rating"], ["asc"]);
      this.setState({
        columns: {
          ...this.state.columns,
          [columnId]: {
            name: name,
            bgColor: column.bgColor,
            items: sortedAscending,
            length: column.length,
          },
        },
      });
    } else if (sortby == "firstsubmitted") {
      let sortFirstsubmitted = _.orderBy(
        column.items,
        ["submission_date"],
        ["asc"]
      );

      this.setState({
        columns: {
          ...this.state.columns,
          [columnId]: {
            name: name,
            bgColor: column.bgColor,
            items: sortFirstsubmitted,
            length: column.length,
          },
        },
      });
    } else if (sortby == "lastsubmitted") {
      let sortLastsubmitted = _.orderBy(
        column.items,
        ["submission_date"],
        ["desc"]
      );
      this.setState({
        columns: {
          ...this.state.columns,
          [columnId]: {
            name: name,
            bgColor: column.bgColor,
            items: sortLastsubmitted,
            length: column.length,
          },
        },
      });
    } else {
      let sortDisplayorder = _.orderBy(
        column.items,
        ["display_order"],
        ["asc"]
      );
      this.setState({
        columns: {
          ...this.state.columns,
          [columnId]: {
            name: name,
            bgColor: column.bgColor,
            items: sortDisplayorder,
            length: column.length,
          },
        },
      });
    }
  };

  viewResponse = (e, response) => {
    // console.log('response',response)
    let bgColor = "";
    let status = response.status;
    if (response.status == "reviewed" && response.markas == "reject") {
      status = "rejected";
      bgColor = "#FF6868";
    } else if (response.status == "unreviewed") {
      bgColor = "#F6AB2E";
    } else if (response.status == "reviewed" && response.markas != "reject") {
      bgColor = "#105EFB";
    } else if (response.status == "shortlisted") {
      bgColor = "#22B576";
    }

    this.props.openProposalResponseModal(true, response, status, bgColor);
  };

  render() {
    // console.log('this.state.shimmerLoading',this.state.shimmerLoading)
    //     -Highest rating
    // -Lowest rating
    // -First submitted
    // -last submitted
    let sortoptions = [];

    sortoptions.push(
      <option
        value="none"
        selected={this.state.sortby === "none" ? "selected" : ""}
      >
        {LocaleStrings.proposal_sort}
      </option>
    );
    sortoptions.push(
      <option
        value="highestrating"
        selected={this.state.sortby === "highestrating" ? "selected" : ""}
      >
        Highest rating
      </option>
    );
    sortoptions.push(
      <option
        value="lowestrating"
        selected={this.state.sortby === "lowestrating" ? "selected" : ""}
      >
        Lowest rating
      </option>
    );
    sortoptions.push(
      <option
        value="firstsubmitted"
        selected={this.state.sortby === "firstsubmitted" ? "selected" : ""}
      >
        First submitted
      </option>
    );
    sortoptions.push(
      <option
        value="lastsubmitted"
        selected={this.state.sortby === "lastsubmitted" ? "selected" : ""}
      >
        Last submitted
      </option>
    );
    // console.log('non',this.state.nonClickableid)
    // console.log('shimmer',this.state.shimmerLoading)
    return (
      <div style={{ display: "flex", height: "100%" }}>
        <DragDropContext
          onDragEnd={(result) => this.onDragEnd(result, this.state.columns)}
        >
          {Object.entries(this.state.columns).map(
            ([columnId, column], index) => {
              return (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    // alignItems: "center"
                  }}
                  key={columnId}
                >
                  <div
                    className=""
                    style={{ display: "flex", marginLeft: "7px" }}
                  >
                    <span
                      className="proposal-header-box"
                      style={{
                        backgroundColor: column.bgColor,
                        marginTop: "10px",
                      }}
                    ></span>
                    <span
                      className="proposal-status"
                      style={{ marginTop: "10px" }}
                    >
                      {column.name}
                    </span>
                    <span
                      className="proposal-status"
                      style={{ marginTop: "10px" }}
                    >
                      ({column.length})
                    </span>
                    <span
                      className=""
                      style={{ marginLeft: "auto", marginRight: "10px" }}
                    >
                      <select
                        id="sortbyHandle"
                        // className="form-control"
                        onChange={(e) =>
                          this.handleSortBy(e, index, column, columnId)
                        }
                        className="form-control selectbox dropdown-height-border"
                        // style={{width:'45%'}}
                      >
                        {sortoptions}
                      </select>
                    </span>
                  </div>
                  <div style={{ margin: 8 }}>
                    <Droppable droppableId={columnId} key={columnId}>
                      {(provided, snapshot) => {
                        return (
                          <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            className="drag-box-proposal"
                            style={{
                              background: snapshot.isDraggingOver
                                ? "lightblue"
                                : "#E6E8EA",
                            }}
                          >
                            {column.items.map((item, index) => {
                              let section = "";
                              if (
                                item.proposal_review_by_responseidfk &&
                                item.proposal_review_by_responseidfk.length > 0
                              ) {
                                let sumRating = _.sumBy(
                                  item.proposal_review_by_responseidfk,
                                  function (o) {
                                    return o.rating;
                                  }
                                );
                                section = (
                                  sumRating /
                                  item.proposal_review_by_responseidfk.length
                                ).toFixed(2);
                              }

                              return (
                                <span>
                                  {parseInt(this.state.nonClickableid) ===
                                    parseInt(item.id) &&
                                  this.state.shimmerLoading == true ? (
                                    <div>
                                      <ShimmerEffect />
                                    </div>
                                  ) : (
                                    <Draggable
                                      key={item.id}
                                      draggableId={item.id.toString()}
                                      index={index}
                                    >
                                      {(provided, snapshot) => {
                                        return (
                                          <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={{
                                              userSelect: "none",
                                              padding: 16,
                                              margin: "8px",

                                              // width: '264px',
                                              height: "135px",
                                              backgroundColor:
                                                snapshot.isDragging
                                                  ? "#263B4A"
                                                  : "#FFFFFF",
                                              color: "white",
                                              borderTopLeftRadius: "5px",
                                              borderBottomRightRadius: "5px",
                                              borderBottomLeftRadius: "5px",
                                              borderTopRightRadius: "5px",
                                              ...provided.draggableProps.style,
                                            }}
                                            onClick={(e) =>
                                              this.viewResponse(e, item)
                                            }
                                          >
                                           
                                            <div className="proposal-response-headText">
                                              {item.firstname} {item.lastname}
                                            </div>
                                            <div className="proposal-submission-date">
                                              {converDateIntoLocalwithmonth(
                                                item.submission_date
                                              ).format("D MMM YYYY HH:mm A")}
                                            </div>
                                            <div
                                              className=""
                                              style={{
                                                marginTop: "15px",
                                                display: "flex",
                                              }}
                                            >
                                              {item.proposal_by_proposalidfk
                                                .category != "" && item.proposal_by_proposalidfk
                                                .category != null ? (
                                                <div className="proposal-category">
                                                  {_.startCase(
                                                    item
                                                      .proposal_by_proposalidfk
                                                      .category
                                                  )}
                                                </div>
                                              ) : (
                                                ""
                                              )}

                                              {section != "" ? (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    marginLeft: "10px",
                                                  }}
                                                >
                                                  <img
                                                    src="../../style/images/yellowstar.png"
                                                    style={{
                                                      marginRight: "10px",
                                                      height: "20px",
                                                    }}
                                                  />
                                                  <span
                                                    style={{ color: "#18203A" }}
                                                  >
                                                    {" "}
                                                    {section}
                                                  </span>
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                            </div>
                                            <div
                                              className=""
                                              style={{
                                                marginTop: "6px",
                                                display: "flex",
                                              }}
                                            >
                                              <div
                                                className="proposal-assignedto"
                                                style={{ paddingRight: "5px" }}
                                              >
                                                Assigned to:
                                              </div>

                                              <div
                                                className=""
                                                style={{ color: "#105EFB" }}
                                              >
                                                {item.reviewer_by_reviewerid ? (
                                                  <span>
                                                    {_.startCase(
                                                      item
                                                        .reviewer_by_reviewerid
                                                        .username
                                                    )}{" "}
                                                  </span>
                                                ) : (
                                                  <span>Admin</span>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        );
                                      }}
                                    </Draggable>
                                  )}
                                </span>
                              );
                            })}

                            {provided.placeholder}
                          </div>
                        );
                      }}
                    </Droppable>
                  </div>
                </div>
              );
            }
          )}
        </DragDropContext>
      </div>
    );
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
    unreviewedproposalList: state.unreviewedproposalList,
    reviewedproposalList: state.reviewedproposalList,
    shortlistedproposalList: state.shortlistedproposalList,
    rejectedproposalList: state.rejectedproposalList,
    proposalAttendeeList: state.proposalAttendeeList,
    allresponseProposal: state.allresponseProposal,
    updatedProposalLoader: state.updatedProposalLoader,
    sortbyFilter: state.sortbyFilter,
  };
};

export default connect(mapStateToProps, {
  openProposalResponseModal,
  updateProposalStatus,
  showSuccess,
  showError,
  fetchUnreviewedproposal,
  fetchReviewedproposal,
  fetchShortlistedproposal,
  fetchRejectedproposal,
  fetchallproposal,
  updatedDragProposal,
  filterProposalLoader,
  deleteProposalRank,
  sortByfilter,
})(DragableProposal);
